import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "row m-4 mb-0 mt-0" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "card card-body mb-0" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_7 = { class: "col p-0" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_10 = { class: "col p-0" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_13 = { class: "col p-0" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_16 = { class: "col p-0" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_19 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_20 = { class: "col p-0" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_23 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_24 = { class: "col p-0" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_27 = { class: "col p-0" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_30 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_31 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_32 = { class: "col p-0" }
const _hoisted_33 = { class: "" }
const _hoisted_34 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_35 = { class: "col p-0" }
const _hoisted_36 = { class: "" }
const _hoisted_37 = {
  key: 0,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_38 = { class: "col p-0" }
const _hoisted_39 = { class: "" }
const _hoisted_40 = ["disabled", "placeholder"]
const _hoisted_41 = {
  key: 1,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_42 = { class: "col p-0" }
const _hoisted_43 = { class: "" }
const _hoisted_44 = ["disabled", "placeholder"]
const _hoisted_45 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_46 = { class: "col p-0" }
const _hoisted_47 = { class: "" }
const _hoisted_48 = { class: "form-group mb-2 col" }
const _hoisted_49 = { class: "col-auto p-0 text-end" }
const _hoisted_50 = { class: "row mt-3" }
const _hoisted_51 = { class: "form-group mb-2 col-sm-12 me-2" }
const _hoisted_52 = { class: "col p-0" }
const _hoisted_53 = { class: "" }
const _hoisted_54 = { class: "me-2" }
const _hoisted_55 = ["value", "id"]
const _hoisted_56 = ["for"]
const _hoisted_57 = { class: "row m-4 mb-0 mt-0 ms-3 me-3" }
const _hoisted_58 = { class: "col-xs-12 col-lg-6 mb-3 ps-2 pe-2" }
const _hoisted_59 = { class: "card card-default h-100" }
const _hoisted_60 = { class: "card-body p-1 p-lg-2" }
const _hoisted_61 = { class: "d-block text-center" }
const _hoisted_62 = { class: "col-xs-12 col-lg-6 mb-3 ps-2 pe-2" }
const _hoisted_63 = { class: "card card-default h-100" }
const _hoisted_64 = { class: "card-body p-1 p-lg-2" }
const _hoisted_65 = { class: "d-block text-center" }
const _hoisted_66 = { class: "row m-4 mb-0 mt-0 ms-3 me-3" }
const _hoisted_67 = { class: "col-xs-12 col-lg-6 mb-3 ps-2 pe-2" }
const _hoisted_68 = { class: "card card-default h-100" }
const _hoisted_69 = { class: "card-body p-1 p-lg-2" }
const _hoisted_70 = { class: "d-block text-center" }
const _hoisted_71 = { class: "col-xs-12 col-lg-6 mb-3 ps-2 pe-2" }
const _hoisted_72 = { class: "card card-default h-100" }
const _hoisted_73 = { class: "card-body p-1 p-lg-2" }
const _hoisted_74 = { class: "d-block text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MerchantMultiselect = _resolveComponent("MerchantMultiselect")!
  const _component_StoreMultiselect = _resolveComponent("StoreMultiselect")!
  const _component_TrafficGroupMultiselect = _resolveComponent("TrafficGroupMultiselect")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Bar = _resolveComponent("Bar")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_MerchantMultiselect, {
                    multiple: true,
                    modelValue: _ctx.merchantsFilter,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.merchantsFilter) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_StoreMultiselect, {
                    multiple: true,
                    modelValue: _ctx.storesFilter,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storesFilter) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_TrafficGroupMultiselect, {
                    multiple: true,
                    small: "",
                    modelValue: _ctx.trafficGroupsFilter,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trafficGroupsFilter) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_DatePicker, {
                    modelValue: _ctx.requestDTO.fromDate,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
                    mode: "dateTime",
                    "model-modifiers": {string: true},
                    is24hr: "",
                    masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                  }, {
                    default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                      _createElementVNode("input", {
                        class: "form-control form-control-sm",
                        placeholder: _ctx.helper.trans('labels.from_date'),
                        value: inputValue,
                        onFocus: togglePopover,
                        onChange: inputEvents.change
                      }, null, 40, _hoisted_18)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_DatePicker, {
                    modelValue: _ctx.requestDTO.toDate,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
                    mode: "dateTime",
                    "model-modifiers": {string: true},
                    is24hr: "",
                    masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                  }, {
                    default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                      _createElementVNode("input", {
                        class: "form-control form-control-sm",
                        placeholder: _ctx.helper.trans('labels.to_date'),
                        value: inputValue,
                        onFocus: togglePopover,
                        onChange: inputEvents.change
                      }, null, 40, _hoisted_22)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_TraderMultiselect, {
                    multiple: true,
                    modelValue: _ctx.tradersFilter,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tradersFilter) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_Multiselect, {
                    id: "methods",
                    class: "multiselect-sm",
                    modelValue: _ctx.requestDTO.methods,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestDTO.methods) = $event)),
                    options: _ctx.store.getters['currencyMethods/methods'](),
                    "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                    multiple: true,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.payment_methods')
                  }, {
                    option: _withCtx((props) => [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_PayMethodIcon, {
                          "icon-class": "icon",
                          method: props.option
                        }, null, 8, ["method"]),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "custom-label", "placeholder"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_Multiselect, {
                    id: "options",
                    class: "multiselect-sm",
                    modelValue: _ctx.requestDTO.options,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestDTO.options) = $event)),
                    options: _ctx.store.getters['currencyMethods/options'](),
                    "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                    multiple: true,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.payment_options')
                  }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_Multiselect, {
                    id: "currency",
                    class: "multiselect-sm multiselect-capitalize",
                    modelValue: _ctx.requestDTO.currency,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestDTO.currency) = $event)),
                    options: _ctx.store.getters['currencyMethods/currencies'],
                    "custom-label": (opt) => opt,
                    multiple: false,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.currency')
                  }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                ])
              ])
            ]),
            (_ctx.isAdmin || _ctx.isOperator)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        disabled: !_ctx.requestDTO.currency,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requestDTO.amountFrom) = $event)),
                        class: "form-control form-control-sm",
                        placeholder: _ctx.helper.trans('labels.from_sum')
                      }, null, 8, _hoisted_40), [
                        [_vModelText, _ctx.requestDTO.amountFrom]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAdmin || _ctx.isOperator)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        disabled: !_ctx.requestDTO.currency,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.requestDTO.amountTo) = $event)),
                        class: "form-control form-control-sm",
                        placeholder: _ctx.helper.trans('labels.to_sum')
                      }, null, 8, _hoisted_44), [
                        [_vModelText, _ctx.requestDTO.amountTo]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_Multiselect, {
                    id: "types",
                    class: "multiselect-sm",
                    modelValue: _ctx.requestDTO.types,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.requestDTO.types) = $event)),
                    options: Object.values(_ctx.Direction),
                    "custom-label": (opt) => _ctx.helper.trans(`direction.${opt}`),
                    multiple: true,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.type')
                  }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[12] || (_cache[12] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                  class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[13] || (_cache[13] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                  class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.helper.trans('labels.group_by')), 1),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([10,30,60], (period) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.requestDTO.periodMinutes) = $event)),
                        value: period,
                        class: "btn-check",
                        name: "options-outlined",
                        id: `group-${period}`,
                        autocomplete: "off"
                      }, null, 8, _hoisted_55), [
                        [_vModelRadio, _ctx.requestDTO.periodMinutes]
                      ]),
                      _createElementVNode("label", {
                        class: "btn btn-sm btn-outline-dark me-2",
                        for: `group-${period}`
                      }, _toDisplayString(period) + " " + _toDisplayString(_ctx.helper.trans('labels.minutes')), 9, _hoisted_56)
                    ], 64))
                  }), 64))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_LoaderWrapper, {
      ref: "loaderOnline",
      class: "h-100"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.helper.trans('labels.count_online_stat')), 1),
                _createVNode(_component_Bar, {
                  "chart-options": _ctx.onlineChartOptions,
                  "chart-data": _ctx.onlineChartData
                }, null, 8, ["chart-options", "chart-data"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.helper.trans('labels.volume_online_stat')), 1),
                _createVNode(_component_Bar, {
                  "chart-options": _ctx.onlineVolumeOptions,
                  "chart-data": _ctx.onlineVolumeData
                }, null, 8, ["chart-options", "chart-data"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.helper.trans('labels.traders')), 1),
                _createVNode(_component_Bar, {
                  "chart-options": _ctx.onlineChartOptions,
                  "chart-data": _ctx.onlineTradersData
                }, null, 8, ["chart-options", "chart-data"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.helper.trans('labels.amount_online_stat', {minutes: _ctx.requestDTO.periodMinutes })), 1),
                _createVNode(_component_Bar, {
                  "chart-options": _ctx.onlineAmountChartOptions,
                  "chart-data": _ctx.onlineAmountsData
                }, null, 8, ["chart-options", "chart-data"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}